import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CaseDetailPage from './pages/CaseDetailPage';
import PaymentPage from './pages/PaymentPage';
import ChatPage from './pages/ChatPage';
import DocumentsPage from './pages/DocumentsPage';
import HardshipPage from './pages/HardshipPage';
import DemoInfoPage from './pages/DemoInfoPage';
import { authService } from './services/authService';
import type { Debtor } from './types';
import './App.css';

function App() {
  const [currentDebtor, setCurrentDebtor] = useState<Debtor | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for existing session
    const debtor = authService.getCurrentDebtor();
    if (debtor) {
      setCurrentDebtor(debtor);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (debtor: Debtor) => {
    setCurrentDebtor(debtor);
  };

  const handleLogout = () => {
    authService.logout();
    setCurrentDebtor(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={
          currentDebtor 
            ? <Navigate to="/dashboard" replace /> 
            : <LoginPage onLogin={handleLogin} />
        } 
      />
      <Route path="/demo-info" element={<DemoInfoPage debtor={currentDebtor} />} />
      
      {/* Protected routes */}
      <Route 
        path="/dashboard" 
        element={
          currentDebtor 
            ? <DashboardPage debtor={currentDebtor} onLogout={handleLogout} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/case/:caseId" 
        element={
          currentDebtor 
            ? <CaseDetailPage debtor={currentDebtor} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/payment/:caseId" 
        element={
          currentDebtor 
            ? <PaymentPage debtor={currentDebtor} />
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/payment" 
        element={
          currentDebtor 
            ? <PaymentPage debtor={currentDebtor} />
            : <Navigate to="/login" replace />
        } 
      />
      <Route
        path="/chat" 
        element={
          currentDebtor 
            ? <ChatPage debtor={currentDebtor} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/documents" 
        element={
          currentDebtor 
            ? <DocumentsPage debtor={currentDebtor} /> 
            : <Navigate to="/login" replace />
        } 
      />
      <Route 
        path="/hardship" 
        element={
          currentDebtor 
            ? <HardshipPage debtor={currentDebtor} /> 
            : <Navigate to="/login" replace />
        } 
      />
      
      {/* Default redirect */}
      <Route path="*" element={<Navigate to={currentDebtor ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

export default App;
